import backofficeService from "../../api/backoffice";

export default {
  // =========================
  // Templates (Admin)
  // =========================
  getTemplates(params) {
    return backofficeService
      .Api()
      .get("termMaterials/templates", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  getTemplateById(id, params = {}) {
    return backofficeService
      .Api()
      .get(`termMaterials/templates/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  createTemplate(data) {
    return backofficeService
      .Api()
      .post("termMaterials/templates", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  updateTemplate(id, data) {
    return backofficeService
      .Api()
      .put(`termMaterials/templates/${id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  deleteTemplate(id, params = {}) {
    return backofficeService
      .Api()
      .delete(`termMaterials/templates/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  // =========================
  // Assign template to a classroom + term (Admin)
  // =========================
  assignTemplate(data) {
    // data: { ClassRoomId, TermId, TermMaterialTemplateId }
    return backofficeService
      .Api()
      .post("termMaterials/assign", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  // =========================
  // Teacher side (later step)
  // =========================
  getForm(params) {
    // params: { ClassRoomId, TermId }
    return backofficeService
      .Api()
      .get("termMaterials/form", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  saveResponse(data) {
    // data: { ClassRoomId, TermId, answers: [{ key, value }] }
    return backofficeService
      .Api()
      .post("termMaterials/response", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};